import React from "react";
import GuestPrizeRoll from "../../components/GuestPrizeRoll";

export default function GuestPrizeII() {
  return (
    <GuestPrizeRoll
      title="DOORPRIZE SESI II"
      prizeType="guest_prize_2"
      spinEndpoint="spinGuestPrize2Winner"
      winnerEndpoint="getGuestPrize2Winner"
      emptyMessage="Semua hadiah Doorprize Sesi II sudah keluar."
    />
  );
}
